import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PDNFandPCNF = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="PCNF and PDNF"
    videos={[
      "https://www.youtube.com/embed/_9FzypwmYns",
      "https://www.youtube.com/embed/mEo2scHCe48",
    ]}
    takeaways={[
      { text: "PDNF = Sum of minterms (f = 1)" },
      { text: "PCNF = Product of maxterms (f = 0)" },
      { text: "To expand PDNF: Multiply by (p ∨ ¬p) to include all variables" },
      { text: "To expand PCNF: Add with (p ∧ ¬p) to include all variables" },
      { text: "Practice for three variables" }
    ]}
    questions={[
      "Obtain PDNF and PCNF of the statement formula: (P→(Q ∧ R)) ∧ (P'→((Q') ∧ (R')))",
      "Obtain PDNF and PCNF of the statement formula: (P∧Q) V (P∧R) V (Q∧R) with truth table and without truth table method",
      "Find the PDNF and PCNF of S⇔(P→Q')∧(Q→R)∧(P∧R')'∧(P∨R') and hence find whether S is a tautology or contradiction",
      "Obtain the PDNF and PCNF of (P' V Q') → (P' ∧ R)"
    ]}
    exampleVideos={[]}
  />
);
}

export default PDNFandPCNF;
